// import React, { useState } from 'react';
// import styled from 'styled-components';

// // --- STYLED COMPONENTS (Clean, Modern Light Mode Design without Header/Navbar) ---

// const Container = styled.div`
//   background-color: #f8fafc;
//   color: #0f172a;
//   font-family: 'Inter', system-ui, -apple-system, sans-serif;
//   min-height: 100vh;
//   overflow-x: hidden;
// `;

// const HeroSection = styled.header`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
//   padding: 80px 20px 60px 20px;
//   background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
//   border-bottom: 1px solid #e2e8f0;
// `;

// const Badge = styled.span`
//   background-color: #e0f2fe;
//   color: #0284c7;
//   padding: 6px 16px;
//   border-radius: 20px;
//   font-size: 0.85rem;
//   font-weight: 600;
//   margin-bottom: 20px;
//   border: 1px solid #bae6fd;
// `;

// const Title = styled.h1`
//   font-size: 3.5rem;
//   max-width: 900px;
//   line-height: 1.2;
//   margin-bottom: 20px;
//   font-weight: 800;
//   color: #0f172a;

//   span {
//     background: linear-gradient(135deg, #0284c7, #4f46e5);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//   }

//   @media(max-width: 768px) {
//     font-size: 2.3rem;
//   }
// `;

// const Subtitle = styled.p`
//   font-size: 1.2rem;
//   color: #475569;
//   max-width: 650px;
//   margin-bottom: 40px;
//   line-height: 1.6;
// `;

// const CTAButton = styled.button`
//   background: linear-gradient(135deg, #0ea5e9, #4f46e5);
//   color: #ffffff;
//   border: none;
//   padding: 16px 36px;
//   font-size: 1rem;
//   font-weight: 700;
//   border-radius: 8px;
//   cursor: pointer;
//   box-shadow: 0 10px 25px -5px rgba(14, 165, 233, 0.3);
//   transition: transform 0.2s, box-shadow 0.2s;

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 15px 30px -5px rgba(14, 165, 233, 0.5);
//   }
// `;

// const StatsSection = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//   gap: 30px;
//   max-width: 1000px;
//   margin: 0 auto;
//   padding: 40px 20px;
//   border-bottom: 1px solid #e2e8f0;
//   text-align: center;
// `;

// const StatItem = styled.div`
//   h3 {
//     font-size: 2.2rem;
//     color: #0284c7;
//     margin-bottom: 5px;
//   }
//   p {
//     color: #64748b;
//     font-size: 0.95rem;
//   }
// `;

// const MainContentSection = styled.section`
//   max-width: 1200px;
//   margin: 0 auto;
//   padding: 80px 20px;
// `;

// const SectionHeader = styled.div`
//   text-align: center;
//   margin-bottom: 50px;

//   h2 {
//     font-size: 2.5rem;
//     margin-bottom: 15px;
//     font-weight: 700;
//     color: #0f172a;
//   }

//   p {
//     color: #475569;
//     font-size: 1.1rem;
//   }
// `;

// const CategorySelector = styled.div`
//   display: flex;
//   justify-content: center;
//   gap: 20px;
//   margin-bottom: 50px;
// `;

// const TabButton = styled.button`
//   background-color: ${(props) => (props.active ? '#0ea5e9' : '#ffffff')};
//   color: ${(props) => (props.active ? '#ffffff' : '#334155')};
//   border: 1px solid ${(props) => (props.active ? '#0ea5e9' : '#cbd5e1')};
//   padding: 14px 32px;
//   font-size: 1rem;
//   font-weight: 700;
//   border-radius: 12px;
//   cursor: pointer;
//   transition: all 0.3s ease;
//   box-shadow: ${(props) => (props.active ? '0 4px 14px rgba(14, 165, 233, 0.3)' : '0 2px 4px rgba(0,0,0,0.02)')};

//   &:hover {
//     border-color: #0ea5e9;
//   }
// `;

// const Grid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
//   gap: 30px;

//   @media(max-width: 480px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const Card = styled.div`
//   background: #ffffff;
//   border-radius: 16px;
//   overflow: hidden;
//   border: 1px solid #e2e8f0;
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
//   transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;

//   &:hover {
//     transform: translateY(-5px);
//     border-color: #0ea5e9;
//     box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08);
//   }
// `;

// const CardImageContainer = styled.div`
//   position: relative;
//   height: 200px;
//   overflow: hidden;

//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     transition: transform 0.5s;
//   }

//   ${Card}:hover & img {
//     transform: scale(1.05);
//   }
// `;

// const LevelBadge = styled.span`
//   position: absolute;
//   top: 15px;
//   right: 15px;
//   background: rgba(255, 255, 255, 0.9);
//   backdrop-filter: blur(5px);
//   color: #0369a1;
//   padding: 5px 12px;
//   border-radius: 6px;
//   font-size: 0.75rem;
//   font-weight: 600;
//   border: 1px solid #bae6fd;
// `;

// const CardContent = styled.div`
//   padding: 25px;
//   display: flex;
//   flex-direction: column;
//   gap: 12px;
//   flex-grow: 1;
// `;

// const CourseMeta = styled.div`
//   display: flex;
//   justify-content: space-between;
//   color: #64748b;
//   font-size: 0.85rem;
//   font-weight: 500;
// `;

// const CourseTitle = styled.h3`
//   font-size: 1.4rem;
//   margin: 0;
//   color: #0f172a;
//   font-weight: 700;
// `;

// const CourseDescription = styled.p`
//   font-size: 0.95rem;
//   color: #475569;
//   margin: 0;
//   line-height: 1.5;
// `;

// const CardFooter = styled.div`
//   padding: 20px 25px;
//   border-top: 1px solid #f1f5f9;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   background: #f8fafc;
// `;

// const PriceTag = styled.span`
//   font-size: 1.25rem;
//   font-weight: 800;
//   color: #0284c7;
// `;

// const LearnMoreButton = styled.button`
//   background-color: transparent;
//   color: #0284c7;
//   border: 1px solid #0284c7;
//   padding: 10px 20px;
//   font-size: 0.9rem;
//   font-weight: 600;
//   border-radius: 8px;
//   cursor: pointer;
//   transition: all 0.2s;

//   &:hover {
//     background-color: #0284c7;
//     color: #ffffff;
//   }
// `;

// const FeaturesSection = styled.section`
//   background: #ffffff;
//   padding: 100px 20px;
//   border-top: 1px solid #e2e8f0;
//   border-bottom: 1px solid #e2e8f0;
// `;

// const FeaturesGrid = styled.div`
//   max-width: 1200px;
//   margin: 0 auto;
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//   gap: 40px;
// `;

// const FeatureCard = styled.div`
//   background: #f8fafc;
//   padding: 35px;
//   border-radius: 16px;
//   border: 1px solid #e2e8f0;

//   div.icon {
//     font-size: 2.5rem;
//     margin-bottom: 20px;
//   }

//   h3 {
//     font-size: 1.25rem;
//     margin-bottom: 12px;
//     color: #0f172a;
//   }

//   p {
//     color: #475569;
//     line-height: 1.6;
//     font-size: 0.95rem;
//     margin: 0;
//   }
// `;

// const TestimonialsSection = styled.section`
//   max-width: 1200px;
//   margin: 0 auto;
//   padding: 100px 20px;
// `;

// const TestimonialGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
//   gap: 30px;
// `;

// const TestimonialCard = styled.div`
//   background: #ffffff;
//   padding: 30px;
//   border-radius: 16px;
//   border: 1px solid #e2e8f0;
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   gap: 20px;
//   box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);

//   p {
//     color: #334155;
//     font-style: italic;
//     line-height: 1.6;
//     margin: 0;
//   }
// `;

// const AuthorInfo = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 15px;

//   img {
//     width: 50px;
//     height: 50px;
//     border-radius: 50%;
//     object-fit: cover;
//   }

//   h4 {
//     margin: 0;
//     color: #0f172a;
//     font-size: 1rem;
//   }

//   span {
//     color: #0284c7;
//     font-size: 0.85rem;
//   }
// `;

// const FAQSection = styled.section`
//   max-width: 800px;
//   margin: 0 auto;
//   padding: 20px 20px 100px 20px;
// `;

// const FAQItem = styled.div`
//   background: #ffffff;
//   border: 1px solid #e2e8f0;
//   border-radius: 12px;
//   padding: 24px;
//   margin-bottom: 16px;
//   box-shadow: 0 2px 4px rgba(0,0,0,0.01);

//   h3 {
//     font-size: 1.1rem;
//     margin: 0 0 10px 0;
//     color: #0f172a;
//   }

//   p {
//     margin: 0;
//     color: #475569;
//     line-height: 1.5;
//     font-size: 0.95rem;
//   }
// `;

// const ModalOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background: rgba(15, 23, 42, 0.5);
//   backdrop-filter: blur(4px);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   padding: 20px;
//   z-index: 1000;
// `;

// const ModalContent = styled.div`
//   background: #ffffff;
//   padding: 40px;
//   border-radius: 20px;
//   max-width: 550px;
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   gap: 20px;
//   border: 1px solid #e2e8f0;
//   position: relative;
//   box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);

//   h2 {
//     margin: 0;
//     font-size: 1.8rem;
//     color: #0f172a;
//   }

//   p {
//     color: #475569;
//     line-height: 1.6;
//     margin: 0;
//   }
// `;

// const CloseButton = styled.button`
//   position: absolute;
//   top: 20px;
//   right: 20px;
//   background: #f1f5f9;
//   color: #0f172a;
//   border: none;
//   width: 36px;
//   height: 36px;
//   border-radius: 50%;
//   font-weight: bold;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: background 0.2s;

//   &:hover {
//     background: #e2e8f0;
//   }
// `;

// const ModalDetailsList = styled.ul`
//   list-style: none;
//   padding: 0;
//   margin: 0;
//   display: flex;
//   flex-direction: column;
//   gap: 10px;

//   li {
//     color: #334155;
//     font-size: 0.95rem;
//     display: flex;
//     align-items: center;
//     gap: 10px;

//     &::before {
//       content: '✓';
//       color: #0284c7;
//       font-weight: bold;
//     }
//   }
// `;

// const EnrollButton = styled(CTAButton)`
//   width: 100%;
//   margin-top: 10px;
// `;

// // --- DATA SOURCE ---

// const coursesData = {
//   online: [
//     {
//       id: 1,
//       title: 'Full-Stack Web Development Mastery',
//       level: 'Intermediate',
//       duration: '16 Weeks',
//       price: 850,
//       type:'online',
//       description: 'Master modern frontend and backend tech stacks including React, Node.js, Express, and PostgreSQL with live virtual mentorship.',
//       image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=800&q=80',
//       modules: ['Advanced React & Redux Toolkit', 'Node.js & Restful APIs', 'Database Design & ORM', 'Deployment & Serverless Architecture']
//     },
//     {
//       id: 2,
//       title: 'Cloud Computing & DevOps Engineering',
//       level: 'Advanced',
//       duration: '12 Weeks',
//       price: 950,
//       type:'online',
//       description: 'Learn AWS architecture, Docker containerization, Kubernetes cluster orchestration, and automated CI/CD deployment pipelines.',
//       image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=800&q=80',
//       modules: ['AWS Core Services & IAM', 'Docker & Containerization', 'Kubernetes Orchestration', 'GitHub Actions & CI/CD']
//     },
//     {
//       id: 3,
//       title: 'Cybersecurity & Ethical Hacking',
//       level: 'Intermediate',
//       duration: '14 Weeks',
//       price: 900,
//       type:'online',
//       description: 'Understand defensive network architecture, penetration testing methodologies, vulnerability assessment, and threat hunting online.',
//       image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=800&q=80',
//       modules: ['Network Security Protocols', 'Penetration Testing Frameworks', 'Web App Vulnerabilities (OWASP Top 10)', 'Incident Response & Forensics']
//     },
//   ],
//   physical: [
//     {
//       id: 4,
//       title: 'Data Science & Machine Learning Bootcamp',
//       level: 'Beginner to Pro',
//       duration: '16 Weeks',
//       price: 1200,
//       type:'physical',
//       description: 'Intensive hands-on physical bootcamp covering Python programming, statistical analysis, deep learning, and predictive modeling frameworks.',
//       image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=800&q=80',
//       modules: ['Python for Data Science', 'Pandas, NumPy & Data Visualization', 'Machine Learning with Scikit-Learn', 'Introduction to Deep Learning & AI']
//     },
//     {
//       id: 5,
//       title: 'Mobile App Engineering & Architecture',
//       level: 'Intermediate',
//       duration: '12 Weeks',
//       price: 1100,
//        type:'physical',
//       description: 'Build production-ready native and cross-platform applications using Flutter and React Native in our state-of-the-art tech studio.',
//       image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=800&q=80',
//       modules: ['Cross-Platform UI with Flutter', 'State Management Solutions', 'Native API Integration', 'App Store & Play Store Deployment']
//     },
//     {
//       id: 6,
//       title: 'Artificial Intelligence & Robotics Studio',
//       level: 'Advanced',
//       duration: '18 Weeks',
//       price: 1500,
//        type:'physical',
//       description: 'Work directly with specialized hardware kits, computer vision algorithms, and neural networks in a collaborative physical workspace.',
//       image: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=800&q=80',
//       modules: ['Computer Vision with OpenCV', 'Neural Networks & PyTorch', 'Robotic Control Systems', 'Capstone Hardware Integration Project']
//     },
//   ],
// };

// // --- REACT COMPONENT ---

// export default function ElexdonLandingPage() {
//   const [selectedCategory, setSelectedCategory] = useState('online');
//   const [modalCourse, setModalCourse] = useState(null);

//   const scrollToCourses = () => {
//     const section = document.getElementById('programs');
//     if (section) {
//       section.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   return (
//     <Container>
//       {/* HERO SECTION (No Navigation/Header included) */}
//       <HeroSection>
//         <Badge>🚀 Accelerate Your Tech Career in 2026</Badge>
//         <Title>
//           Elexdon Digital Academy: <span>Tech Training Programs</span>
//         </Title>
//         <Subtitle>
//           Choose between immersive online interactive sessions or hands-on physical bootcamps designed to transform beginners into industry-ready software engineers, data scientists, and cloud architects.
//         </Subtitle>
//         <CTAButton onClick={scrollToCourses}>Explore Training Programs</CTAButton>
//       </HeroSection>

//       {/* STATS SECTION */}
//       <StatsSection>
//         <StatItem>
//           <h3>95%</h3>
//           <p>Employment Rate</p>
//         </StatItem>
//         <StatItem>
//           <h3>5,000+</h3>
//           <p>Global Graduates</p>
//         </StatItem>
//         <StatItem>
//           <h3>50+</h3>
//           <p>Expert Instructors</p>
//         </StatItem>
//         <StatItem>
//           <h3>4.9/5</h3>
//           <p>Student Satisfaction</p>
//         </StatItem>
//       </StatsSection>

//       {/* MAIN PROGRAMS SECTION */}
//       <MainContentSection id="programs">
//         <SectionHeader>
//           <h2>Our Specialized Training Programs</h2>
//           <p>Select your preferred mode of learning and choose a tech track to begin your journey.</p>
//         </SectionHeader>

//         <CategorySelector>
//           <TabButton
//             active={selectedCategory === 'online'}
//             onClick={() => setSelectedCategory('online')}
//           >
//             💻 Online Training
//           </TabButton>
//           <TabButton
//             active={selectedCategory === 'physical'}
//             onClick={() => setSelectedCategory('physical')}
//           >
//             🏢 Physical Training
//           </TabButton>
//         </CategorySelector>

//         <Grid>
//           {coursesData[selectedCategory].map((course) => (
//             <Card key={course.id}>
//               <CardImageContainer>
//                 <img src={course.image} alt={course.title} />
//                 <LevelBadge>{course.level}</LevelBadge>
//               </CardImageContainer>
//               <CardContent>
//                 <CourseMeta>
//                   <span>⏱ {course.duration}</span>
//                   <span>📍 {selectedCategory.toUpperCase()}</span>
//                 </CourseMeta>
//                 <CourseTitle>{course.title}</CourseTitle>
//                 <CourseDescription>{course.description}</CourseDescription>
//               </CardContent>
//               <CardFooter>
//                 <PriceTag>{course.price}</PriceTag>
//                 <LearnMoreButton onClick={() => setModalCourse(course)}>
//                   Learn More
//                 </LearnMoreButton>
//               </CardFooter>
//             </Card>
//           ))}
//         </Grid>
//       </MainContentSection>

//       {/* WHY CHOOSE US SECTION */}
//       <FeaturesSection id="features">
//         <SectionHeader style={{ marginBottom: '60px' }}>
//           <h2>Why Choose Elexdon Digital Academy?</h2>
//           <p>We provide the ultimate framework for long-term career success in tech.</p>
//         </SectionHeader>
//         <FeaturesGrid>
//           <FeatureCard>
//             <div className="icon">🎯</div>
//             <h3>Project-Based Curriculum</h3>
//             <p>Don't just watch videos. Build a portfolio of real-world applications that impress global engineering hiring managers.</p>
//           </FeatureCard>
//           <FeatureCard>
//             <div className="icon">🤝</div>
//             <h3>1-on-1 Mentorship</h3>
//             <p>Get paired with seasoned tech professionals working at top global companies for weekly guidance and code reviews.</p>
//           </FeatureCard>
//           <FeatureCard>
//             <div className="icon">💼</div>
//             <h3>Career Placement Support</h3>
//             <p>Access our exclusive hiring partner network, resume tailoring sessions, and mock interview practice before graduation.</p>
//           </FeatureCard>
//         </FeaturesGrid>
//       </FeaturesSection>

//       {/* TESTIMONIALS SECTION */}
//       <TestimonialsSection id="testimonials">
//         <SectionHeader>
//           <h2>Success Stories From Our Alumni</h2>
//           <p>Hear how Elexdon changed the career trajectories of our graduates.</p>
//         </SectionHeader>
//         <TestimonialGrid>
//           <TestimonialCard>
//             <p>"The Full-Stack online program gave me the exact skills and confidence I needed. Within two months of graduating, I landed a remote engineering job!"</p>
//             <AuthorInfo>
//               <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80" alt="Sarah J." />
//               <div>
//                 <h4>Sarah Jenkins</h4>
//                 <span>Full-Stack Developer</span>
//               </div>
//             </AuthorInfo>
//           </TestimonialCard>
//           <TestimonialCard>
//             <p>"The physical data science bootcamp environment is unmatched. Access to high-end hardware and direct peer collaboration accelerated my learning tenfold."</p>
//             <AuthorInfo>
//               <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80" alt="David O." />
//               <div>
//                 <h4>David Okoro</h4>
//                 <span>Data Scientist</span>
//               </div>
//             </AuthorInfo>
//           </TestimonialCard>
//         </TestimonialGrid>
//       </TestimonialsSection>

//       {/* FAQ SECTION */}
//       <FAQSection id="faq">
//         <SectionHeader>
//           <h2>Frequently Asked Questions</h2>
//           <p>Got questions? We've got answers.</p>
//         </SectionHeader>
//         <FAQItem>
//           <h3>Do I need prior coding experience to join?</h3>
//           <p>We offer tailored tracks for both absolute beginners and intermediate practitioners looking to upskill.</p>
//         </FAQItem>
//         <FAQItem>
//           <h3>What is the difference between online and physical training?</h3>
//           <p>Online training offers absolute flexibility with live virtual interaction, whereas physical training provides access to our fully equipped tech studios and labs for intensive face-to-face collaboration.</p>
//         </FAQItem>
//         <FAQItem>
//           <h3>Are installment payment plans available?</h3>
//           <p>Yes! We offer flexible split-payment options for all our training programs to make quality education accessible.</p>
//         </FAQItem>
//       </FAQSection>

//       {/* MODAL WINDOW */}
//       {modalCourse && (
//         <ModalOverlay onClick={() => setModalCourse(null)}>
//           <ModalContent onClick={(e) => e.stopPropagation()}>
//             <CloseButton onClick={() => setModalCourse(null)}>✕</CloseButton>
//             <div>
//               <Badge style={{ marginBottom: '10px', display: 'inline-block' }}>{modalCourse.level}</Badge>
//               <h2>{modalCourse.title}</h2>
//             </div>
//             <p>{modalCourse.description}</p>
//             <div>
//               <h4 style={{ color: '#0f172a', marginBottom: '10px' }}>What You Will Master:</h4>
//               <ModalDetailsList>
//                 {modalCourse.modules.map((mod, index) => (
//                   <li key={index}>{mod}</li>
//                 ))}
//               </ModalDetailsList>
//             </div>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
//               <div>
//                 <span style={{ color: '#64748b', fontSize: '0.85rem', display: 'block' }}>Investment</span>
//                 <PriceTag>{modalCourse.price}</PriceTag>
//               </div>
//               <span style={{ color: '#0284c7', fontSize: '0.9rem', fontWeight: '600' }}>Duration: {modalCourse.duration}</span>
//             </div>
//             <EnrollButton onClick={() => alert(`Congratulations! You have successfully enrolled in ${modalCourse.title}. We will reach out with your onboarding details shortly.`)}>
//               Enroll in Program Now
//             </EnrollButton>
//           </ModalContent>
//         </ModalOverlay>
//       )}
//     </Container>
//   );
// }






import React, { useState } from 'react';
import styled from 'styled-components';

// --- STYLED COMPONENTS (Clean, Modern Light Mode Design without Header/Navbar) ---

const Container = styled.div`
  background-color: #f8fafc;
  color: #0f172a;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  min-height: 100vh;
  overflow-x: hidden;
`;


const HeroSection = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 100px 20px 60px 20px;
  min-height: 450px;
  
  /* Dark overlay combined with the Unsplash image */
  background-image: 
    linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), 
    url('https://images.unsplash.com/photo-1531482615713-2afd69097998?q=80&w=1600&auto=format&fit=crop');
    
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  
  border-bottom: 1px solid #e2e8f0;
  
  /* Makes sure your text color inside the hero is white/light for contrast */
  color: #ffffff; 
`;


const Badge = styled.span`
  background-color: #e0f2fe;
  color: #0284c7;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 20px;
  border: 1px solid #bae6fd;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  max-width: 900px;
  line-height: 1.2;
  margin-bottom: 20px;
  font-weight: 800;
  color: white;

  span {
    background: linear-gradient(135deg, #0284c7, #4f46e5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media(max-width: 768px) {
    font-size: 2.3rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: white;
  max-width: 650px;
  margin-bottom: 40px;
  line-height: 1.6;
`;

const CTAButton = styled.button`
  background: linear-gradient(135deg, #0ea5e9, #4f46e5);
  color: #ffffff;
  border: none;
  padding: 16px 36px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 10px 25px -5px rgba(14, 165, 233, 0.3);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 30px -5px rgba(14, 165, 233, 0.5);
  }
`;

const StatsSection = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  max-width: 1000px;
  margin: 0 auto;
  padding: 40px 20px;
  border-bottom: 1px solid #e2e8f0;
  text-align: center;
`;

const StatItem = styled.div`
  h3 {
    font-size: 2.2rem;
    color: #0284c7;
    margin-bottom: 5px;
  }
  p {
    color: #64748b;
    font-size: 0.95rem;
  }
`;

const MainContentSection = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 50px;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 15px;
    font-weight: 700;
    color: #0f172a;
  }

  p {
    color: #475569;
    font-size: 1.1rem;
  }
`;

const CategorySelector = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 50px;
`;

const TabButton = styled.button`
  background-color: ${(props) => (props.active ? '#0ea5e9' : '#ffffff')};
  color: ${(props) => (props.active ? '#ffffff' : '#334155')};
  border: 1px solid ${(props) => (props.active ? '#0ea5e9' : '#cbd5e1')};
  padding: 14px 32px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: ${(props) => (props.active ? '0 4px 14px rgba(14, 165, 233, 0.3)' : '0 2px 4px rgba(0,0,0,0.02)')};

  &:hover {
    border-color: #0ea5e9;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;

  @media(max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s, border-color 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-5px);
    border-color: #0ea5e9;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08);
  }
`;

const CardImageContainer = styled.div`
  position: relative;
  height: 200px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s;
  }

  ${Card}:hover & img {
    transform: scale(1.05);
  }
`;

const LevelBadge = styled.span`
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
  color: #0369a1;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid #bae6fd;
`;

const CardContent = styled.div`
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
`;

const CourseMeta = styled.div`
  display: flex;
  justify-content: space-between;
  color: #64748b;
  font-size: 0.85rem;
  font-weight: 500;
`;

const CourseTitle = styled.h3`
  font-size: 1.4rem;
  margin: 0;
  color: #0f172a;
  font-weight: 700;
`;

const CourseDescription = styled.p`
  font-size: 0.95rem;
  color: #475569;
  margin: 0;
  line-height: 1.5;
`;

const CardFooter = styled.div`
  padding: 20px 25px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8fafc;
`;

const PriceTag = styled.span`
  font-size: 1.25rem;
  font-weight: 800;
  color: #0284c7;
`;

const LearnMoreButton = styled.button`
 background-color: #0284c7;
    color: #ffffff;
  border: 1px solid #0284c7;
  padding: 10px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #0284c7;
    color: #ffffff;
  }
`;

const FeaturesSection = styled.section`
  background: #ffffff;
  padding: 100px 20px;
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
`;

const FeaturesGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
`;

const FeatureCard = styled.div`
  background: #f8fafc;
  padding: 35px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;

  div.icon {
    font-size: 2.5rem;
    margin-bottom: 20px;
  }

  h3 {
    font-size: 1.25rem;
    margin-bottom: 12px;
    color: #0f172a;
  }

  p {
    color: #475569;
    line-height: 1.6;
    font-size: 0.95rem;
    margin: 0;
  }
`;

const TestimonialsSection = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 20px;
`;

const TestimonialGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
`;

const TestimonialCard = styled.div`
  background: #ffffff;
  padding: 30px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);

  p {
    color: #334155;
    font-style: italic;
    line-height: 1.6;
    margin: 0;
  }
`;

const AuthorInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }

  h4 {
    margin: 0;
    color: #0f172a;
    font-size: 1rem;
  }

  span {
    color: #0284c7;
    font-size: 0.85rem;
  }
`;

const FAQSection = styled.section`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 20px 100px 20px;
`;

const FAQItem = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.01);

  h3 {
    font-size: 1.1rem;
    margin: 0 0 10px 0;
    color: #0f172a;
  }

  p {
    margin: 0;
    color: #475569;
    line-height: 1.5;
    font-size: 0.95rem;
  }
`;

// --- DATA SOURCE ---

const coursesData = {
  online: [
    {
      id: 1,
      title: 'Full-Stack Web Development Mastery',
      price: 50000,
      mode: 'online',
      description: 'Master modern frontend and backend tech stacks including React, Node.js, Express, and PostgreSQL with live virtual mentorship.',
      image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=800&q=80',
      modules: ['Advanced React & Redux Toolkit', 'Node.js & Restful APIs', 'Database Design & ORM', 'Deployment & Serverless Architecture']
    },
    {
      id: 2,
      title: 'Cloud Computing & DevOps Engineering',
      price: 55000,
      mode: 'online',
      description: 'Learn AWS architecture, Docker containerization, Kubernetes cluster orchestration, and automated CI/CD deployment pipelines.',
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=800&q=80',
      modules: ['AWS Core Services & IAM', 'Docker & Containerization', 'Kubernetes Orchestration', 'GitHub Actions & CI/CD']
    },
    {
      id: 3,
      title: 'Cybersecurity & Ethical Hacking',
      price: 60000,
      mode: 'online',
      description: 'Understand defensive network architecture, penetration testing methodologies, vulnerability assessment, and threat hunting online.',
      image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=800&q=80',
      modules: ['Network Security Protocols', 'Penetration Testing Frameworks', 'Web App Vulnerabilities (OWASP Top 10)', 'Incident Response & Forensics']
    },
  ],
  physical: [
    {
      id: 4,
      title: 'Data Science & Machine Learning Bootcamp',
      price: 65000,
      mode: 'physical',
      description: 'Intensive hands-on physical bootcamp covering Python programming, statistical analysis, deep learning, and predictive modeling frameworks.',
      image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=800&q=80',
      modules: ['Python for Data Science', 'Pandas, NumPy & Data Visualization', 'Machine Learning with Scikit-Learn', 'Introduction to Deep Learning & AI']
    },
    {
      id: 5,
      title: 'Mobile App Engineering & Architecture',
      price: 70000,
      mode: 'physical',
      description: 'Build production-ready native and cross-platform applications using Flutter and React Native in our state-of-the-art tech studio.',
      image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=800&q=80',
      modules: ['Cross-Platform UI with Flutter', 'State Management Solutions', 'Native API Integration', 'App Store & Play Store Deployment']
    },
    {
      id: 6,
      title: 'Artificial Intelligence & Robotics Studio',
      price: 75000,
    mode: 'physical',
      description: 'Work directly with specialized hardware kits, computer vision algorithms, and neural networks in a collaborative physical workspace.',
      image: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=800&q=80',
      modules: ['Computer Vision with OpenCV', 'Neural Networks & PyTorch', 'Robotic Control Systems', 'Capstone Hardware Integration Project']
    },
  ],
};

// --- REACT COMPONENT ---

export default function ElexdonTrainingPage() {
  const [selectedCategory, setSelectedCategory] = useState('online');

  const scrollToCourses = () => {
    const section = document.getElementById('programs');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLearnMore = (course) => {
    localStorage.setItem('selectedCourse', JSON.stringify(course));
    window.location.href = '/trainingdetail'; // or route to your detail page URL
  };

  return (
    <Container>
      {/* HERO SECTION */}
      <HeroSection>
        {/* <Badge>🚀 Accelerate Your Tech Career in 2026</Badge> */}
        <Title>
          EDA: <span>Tech Training Programs</span>
        </Title>
        <Subtitle>
          Choose between immersive online interactive sessions or hands-on physical bootcamps designed to transform beginners into industry-ready software engineers, data scientists, and cloud architects.
        </Subtitle>
        <CTAButton onClick={scrollToCourses}>Explore Training Programs</CTAButton>
      </HeroSection>

      {/* STATS SECTION */}
      <StatsSection>
        <StatItem>
          <h3>95%</h3>
          <p>Employment Rate</p>
        </StatItem>
        <StatItem>
          <h3>5,000+</h3>
          <p>Global Graduates</p>
        </StatItem>
        <StatItem>
          <h3>50+</h3>
          <p>Expert Instructors</p>
        </StatItem>
        <StatItem>
          <h3>4.9/5</h3>
          <p>Student Satisfaction</p>
        </StatItem>
      </StatsSection>

      {/* MAIN PROGRAMS SECTION */}
      <MainContentSection id="programs">
        <SectionHeader>
          <h2>Our Specialized Training Programs</h2>
          <p>Select your preferred mode of learning and choose a tech track to begin your journey.</p>
        </SectionHeader>

        <CategorySelector>
          <TabButton
            active={selectedCategory === 'online'}
            onClick={() => setSelectedCategory('online')}
          >
            💻 Online Training
          </TabButton>
          <TabButton
            active={selectedCategory === 'physical'}
            onClick={() => setSelectedCategory('physical')}
          >
            🏢 Physical Training
          </TabButton>
        </CategorySelector>

        <Grid>
          {coursesData[selectedCategory].map((course) => (
            <Card key={course.id}>
              <CardImageContainer>
                <img src={course.image} alt={course.title} />
                <LevelBadge>{course.level}</LevelBadge>
              </CardImageContainer>
              <CardContent>
                <CourseMeta>
                  {/* <span>⏱ {course.duration}</span> */}
                  <span>📍 {selectedCategory.toUpperCase()}</span>
                </CourseMeta>
                <CourseTitle>{course.title}</CourseTitle>
                <CourseDescription>{course.description}</CourseDescription>
              </CardContent>
              <CardFooter>
 <PriceTag>₦{Number(course.price).toLocaleString()}</PriceTag>
                <LearnMoreButton onClick={() => handleLearnMore(course)}>
                  Learn More
                </LearnMoreButton>
              </CardFooter>
            </Card>
          ))}
        </Grid>
      </MainContentSection>

      {/* WHY CHOOSE US SECTION */}
      <FeaturesSection id="features">
        <SectionHeader style={{ marginBottom: '60px' }}>
          <h2>Why Choose Elexdon Digital Academy?</h2>
          <p>We provide the ultimate framework for long-term career success in tech.</p>
        </SectionHeader>
        <FeaturesGrid>
          <FeatureCard>
            <div className="icon">🎯</div>
            <h3>Project-Based Curriculum</h3>
            <p>Don't just watch videos. Build a portfolio of real-world applications that impress global engineering hiring managers.</p>
          </FeatureCard>
          <FeatureCard>
            <div className="icon">🤝</div>
            <h3>1-on-1 Mentorship</h3>
            <p>Get paired with seasoned tech professionals working at top global companies for weekly guidance and code reviews.</p>
          </FeatureCard>
          <FeatureCard>
            <div className="icon">💼</div>
            <h3>Career Placement Support</h3>
            <p>Access our exclusive hiring partner network, resume tailoring sessions, and mock interview practice before graduation.</p>
          </FeatureCard>
        </FeaturesGrid>
      </FeaturesSection>

      {/* TESTIMONIALS SECTION */}
      <TestimonialsSection id="testimonials">
        <SectionHeader>
          <h2>Success Stories From Our Alumni</h2>
          <p>Hear how Elexdon changed the career trajectories of our graduates.</p>
        </SectionHeader>
        <TestimonialGrid>
          <TestimonialCard>
            <p>"The Full-Stack online program gave me the exact skills and confidence I needed. Within two months of graduating, I landed a remote engineering job!"</p>
            <AuthorInfo>
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80" alt="Sarah J." />
              <div>
                <h4>Sarah Jenkins</h4>
                <span>Full-Stack Developer</span>
              </div>
            </AuthorInfo>
          </TestimonialCard>
          <TestimonialCard>
            <p>"The physical data science bootcamp environment is unmatched. Access to high-end hardware and direct peer collaboration accelerated my learning tenfold."</p>
            <AuthorInfo>
              <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80" alt="David O." />
              <div>
                <h4>David Okoro</h4>
                <span>Data Scientist</span>
              </div>
            </AuthorInfo>
          </TestimonialCard>
        </TestimonialGrid>
      </TestimonialsSection>

      {/* FAQ SECTION */}
      <FAQSection id="faq">
        <SectionHeader>
          <h2>Frequently Asked Questions</h2>
          <p>Got questions? We've got answers.</p>
        </SectionHeader>
        <FAQItem>
          <h3>Do I need prior coding experience to join?</h3>
          <p>We offer tailored tracks for both absolute beginners and intermediate practitioners looking to upskill.</p>
        </FAQItem>
        <FAQItem>
          <h3>What is the difference between online and physical training?</h3>
          <p>Online training offers absolute flexibility with live virtual interaction, whereas physical training provides access to our fully equipped tech studios and labs for intensive face-to-face collaboration.</p>
        </FAQItem>
        <FAQItem>
          <h3>Are installment payment plans available?</h3>
          <p>Yes! We offer flexible split-payment options for all our training programs to make quality education accessible.</p>
        </FAQItem>
      </FAQSection>
    </Container>
  );
}